module.exports = __webpack_public_path__ + "img/icon-download.b0da9863.svg";